'use strict'

const {NEW_MENU} = require('@wix/component-migration/migrateStylableHorizontalMenuToNewMenu')
const {NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas').namespaceMapping

const entriesToChange = {
    componentType: NEW_MENU.componentType,
    skin: NEW_MENU.skin,
    type: NEW_MENU.type
}

const keysToKeep = [
    'id',
    'styleId',
    'layout',
    'classnamesQuery',
    'transformationQuery',
    'connectionQuery',
    'dataQuery',
    'layoutQuery',
    'slotsQuery',
    'components'
]

const migrateData = (component, pageManager) => {
    const cleanedDataKey = component.dataQuery.replace('#', '')
    const componentData = pageManager.data.getItem(NAMESPACE_MAPPING.data, cleanedDataKey)
    componentData.type = NEW_MENU.dataType
}

const migrateToNewMenuComponent = (component, pageManager) => {
    migrateData(component, pageManager)
    Object.keys(component).forEach(key => keysToKeep.includes(key) || delete component[key])
    Object.entries(entriesToChange).forEach(([key, value]) => (component[key] = value))
}

module.exports = {
    NEW_MENU,
    migrateToNewMenuComponent
}
